<template>
  <button :class="['base-button', buttonLoaderClass, buttonDisabledClass]" :disabled="isDisabled || isLoading">
    <span class="base-button__content">
      <slot/>
      <span class="base-button__text" v-if="text">{{ text }}</span>
    </span>
    <span v-if="isLoading" class="base-button__spinner">
      <spinner/>
    </span>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Spinner from '@/components/common/Spinner.vue'

export interface Props {
  text?: string;
  isDisabled: boolean;
  isLoading: boolean;
}

const props = withDefaults(defineProps<Props>(), { isDisabled: false, isLoading: false })

const buttonDisabledClass = computed(() =>
  props.isDisabled === true ? 'base-button--disabled' : '')
const buttonLoaderClass = computed(() =>
  props.isLoading === true ? 'base-button--loader' : '')
</script>

<style lang="scss">
.base-button {
  $root: #{&};
  border: 2px solid $purple;
  border-radius: 2px;
  background: transparent;
  position: relative;
  color: white;
  cursor: pointer;
  transition: border-color 150ms $animationCurve;

  &:hover {
    border-color: $purple-light;
  }

  > * {
    pointer-events: none;
  }

  &--loader {
    pointer-events: none;
    #{$root}__content {
      visibility: hidden;
    }
  }

  &--disabled {
    border-color: $grey-80;
    cursor: not-allowed;

    &:hover {
      border-color: $grey-80;
    }
  }

  &__content {
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    vertical-align: middle;
  }

  &__spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 0;
  }
}
</style>
